import { useTranslation } from 'react-i18next';

import type { AnyPalette } from '@/entities/palette';

type SystemName = 'pastel' | 'vibrant' | 'business' | 'neutral' | 'warm' | 'cool';
const isSystemName = (value: string): value is SystemName =>
  ['pastel', 'vibrant', 'business', 'neutral', 'warm', 'cool'].includes(value);

/** Localized name / description of a palette: a system one from its stable id, others as stored. */
export function usePaletteNames() {
  const { t } = useTranslation();
  const systemName = (id: string): string => {
    const key = id.replace('system:', '');
    return isSystemName(key) ? t(`palettes.system.${key}.name`) : id;
  };
  return {
    nameOf: (palette: AnyPalette): string =>
      palette.scope === 'system' ? systemName(palette.id) : palette.name,
    systemName,
    descriptionOf: (palette: AnyPalette): string | null => {
      if (palette.scope !== 'system') return null;
      const key = palette.id.replace('system:', '');
      return isSystemName(key) ? t(`palettes.system.${key}.description`) : null;
    },
  };
}
